import React from 'react';
import type { PortalAppearance } from './portalAppearance';
import { usePortalAppearance, useSetPortalAppearance } from './portalAppearanceContext';

const CHOICES: ReadonlyArray<{ value: PortalAppearance; label: string }> = [
  { value: 'light', label: 'Hell' },
  { value: 'dark', label: 'Dunkel' },
];

/** Flieder, fein — gleiche Sprache wie die übrigen Knöpfe in der Schale. */
export const PortalAppearanceSwitch: React.FC<{ className?: string }> = ({ className = '' }) => {
  const appearance = usePortalAppearance();
  const setAppearance = useSetPortalAppearance();

  return (
    <div
      role="group"
      aria-label="Hell oder Dunkel"
      data-testid="portal-appearance-switch"
      className={`grid grid-cols-2 gap-0.5 rounded-lg border p-0.5 ${
        appearance === 'light' ? 'border-[#6a5684] bg-[#f3efe8]' : 'border-violet-400/30 bg-[#07070a]'
      } ${className}`}
    >
      {CHOICES.map(({ value, label }) => {
        const active = appearance === value;
        return (
          <button
            key={value}
            type="button"
            data-testid={`portal-appearance-${value}`}
            aria-pressed={active}
            onClick={() => setAppearance(value)}
            className={`rounded-md px-2 py-1 text-[11px] font-medium transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-violet-400/50 ${
              active
                ? appearance === 'light'
                  ? 'bg-[#5b4678] text-[#f3efe8] ring-1 ring-[#5b4678]'
                  : 'bg-violet-500/15 text-violet-200 ring-1 ring-violet-400/35'
                : appearance === 'light'
                  ? 'text-[#3f3832] hover:bg-[#e6e1d8] hover:text-[#1c1915]'
                  : 'text-slate-500 hover:bg-white/[0.04] hover:text-slate-200'
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};
